/* eslint-disable no-unused-expressions */
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@mui/styles/makeStyles';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';

const useStyles = makeStyles((theme) => ({
  speedDial: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(3),
  },
}));

const SpeedDialMenu = (props) => {
  const classes = useStyles();
  const { options, direction, className } = props;
  const [open, setOpen] = useState(false);

  const handleOpenSpeedDial = useCallback(() => {
    setOpen(true);
  }, []);

  const handleCloseSpeedDial = useCallback(() => {
    setOpen(false);
  }, []);

  const handleSpeedOptionClick = useCallback(
    (onClick) => () => {
      setOpen(false);
      onClick?.();
    },
    []
  );

  if (options.length === 0) return null;

  return (
    <SpeedDial
      ariaLabel="menu"
      direction={direction}
      className={className || classes.speedDial}
      open={open}
      icon={<SpeedDialIcon />}
      onClick={handleOpenSpeedDial}
      onClose={handleCloseSpeedDial}
      onFocus={handleOpenSpeedDial}
      onMouseEnter={handleOpenSpeedDial}
      onMouseLeave={handleCloseSpeedDial}
    >
      {options.map(({ icon, title, onClick }, index) => (
        <SpeedDialAction
          key={index}
          icon={icon}
          tooltipTitle={title}
          onClick={handleSpeedOptionClick(onClick)}
        />
      ))}
    </SpeedDial>
  );
};

SpeedDialMenu.propTypes = {
  direction: PropTypes.string,
  className: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.node.isRequired,
      onClick: PropTypes.func.isRequired,
      icon: PropTypes.node.isRequired,
    })
  ),
};

SpeedDialMenu.defaultProps = {
  className: undefined,
  direction: 'up',
  options: [],
};

export default SpeedDialMenu;
